export default __webpack_public_path__ + "static/media/2023-03-02T06_03_55.720Z_2_6.e0b04c2c.jpeg";